export default "__VITE_ASSET__Bvph7wfz__"